import { render, staticRenderFns } from "./ArgInputContact.vue?vue&type=template&id=522be6e5"
import script from "./ArgInputContact.vue?vue&type=script&lang=ts"
export * from "./ArgInputContact.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522be6e5')) {
      api.createRecord('522be6e5', component.options)
    } else {
      api.reload('522be6e5', component.options)
    }
    module.hot.accept("./ArgInputContact.vue?vue&type=template&id=522be6e5", function () {
      api.rerender('522be6e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scripts/ArgInputContact.vue"
export default component.exports